import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../styles/constant";
import mobileString from "../../assets/icons/mobile-login-string.svg";
import webString from "../../assets/icons/web-login-string.svg";
import useWindowSize from "../../hooks/useWindowSize";
import { tabViewPoint } from "../../utils/constants";
import threeCardsSrc from "../../assets/images/three-cards-web-4x.png";

const CustomOnePlatformBox: FC = () => {
  const { width } = useWindowSize();
  let imgSrc = width < tabViewPoint ? mobileString : webString;

  return (
    <Box
      flexGrow={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box
        textAlign="center"
        display="flex"
        flexDirection="column"
        gap=".25rem"
        marginBottom="1.5rem"
      >
        <Typography fontSize={28} fontWeight={600} color={Colors.white}>
          One Platform
        </Typography>
        <Typography variant="body1" color={Colors.white}>
          For all your, servicing needs
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundImage: `url(${imgSrc})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
        }}
        width="100%"
        display="flex"
        justifyContent="center"
      >
        <img
          src={threeCardsSrc}
          style={{ width: "100%", maxWidth: "311px", margin: "0 1.5rem" }}
        />
      </Box>
    </Box>
  );
};

export default CustomOnePlatformBox;
